// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2xHkf","unreadBadge":"styles_unreadBadge__1hX4u","modalContent":"styles_modalContent__1440q","modal":"styles_modal__2_iWM"};